//Constants
import * as ACTIONS from './actionTypes';

//Types
import { Specials, DateRange, Stats, UserSetting } from './types';
import { ProfilePerformanceStats } from './types';
import { ActionGetOfferInsightsAPISuccess, ActionGetOfferInsightStatsAPISuccess,ActionGetOfferInsightsAPI, ActionSetRangeDates, ActionGetProfilePerformanceInsightStatsAPISuccess, ActionGetUserSettingsAPISuccess } from './actions';
import { DEFAULT_PAGE_SIZE } from './../constants'
import moment from 'moment';


export interface OfferInsightsState {
    profilePerformanceStats?:ProfilePerformanceStats,
    stats?:Stats,
    specials?: Specials,    
    search: string
    orderby:string
    filters:string
    offset: number,
    limit:number,
    datesRange: DateRange|undefined;
    userSettings: UserSetting|undefined;
}

const defaultState: OfferInsightsState = {    
    profilePerformanceStats: undefined,
    stats: undefined,
    specials: undefined,
    search:"",
    orderby:"",
    filters:"",
    offset:0,
    limit: DEFAULT_PAGE_SIZE,
    datesRange: undefined,
    userSettings: undefined
};

type GetOfferInsightsAPIAction = ActionGetOfferInsightsAPISuccess | ActionGetOfferInsightStatsAPISuccess | ActionGetOfferInsightsAPI | ActionGetProfilePerformanceInsightStatsAPISuccess; 

function OfferInsightsReducer(state: OfferInsightsState = defaultState, action: GetOfferInsightsAPIAction ): OfferInsightsState {
    switch (action.type) {
        case ACTIONS.GET_OFFER_INSIGHTSTATS_API_SUCCESS:
            {
                const offerinsightstats = (action as ActionGetOfferInsightStatsAPISuccess).stats
                return{
                    ...state,                    
                    stats: offerinsightstats
                }
            }

        case ACTIONS.GET_PROFILE_PERFORMANCE_INSIGHTS_API_SUCCESS:
            {
                const profileperformancestats = (action as ActionGetProfilePerformanceInsightStatsAPISuccess).profilePerformanceStats
                return{
                    ...state,                    
                    profilePerformanceStats: profileperformancestats
                }
            }
    
        case ACTIONS.GET_OFFER_INSIGHTSTATS_API_SUCCESS:
            {
                const offerinsightstats = (action as ActionGetOfferInsightStatsAPISuccess).stats
                return{
                    ...state,                    
                    stats: offerinsightstats
                }
            }
        case ACTIONS.OFFER_INSIGHTS_NEXT_PAGE:
            {
                return{
                    ...state,                    
                    offset: state.offset + DEFAULT_PAGE_SIZE
                }
            }
        case ACTIONS.OFFER_INSIGHTS_PREV_PAGE:
                {
                    return{
                        ...state,
                        offset: state.offset - DEFAULT_PAGE_SIZE
                    }
                }
        case ACTIONS.GET_OFFER_INSIGHTS_API_SUCCESS:
            {
                const offerinsights = (action as ActionGetOfferInsightsAPISuccess).specials
                return {
                    ...state,
                    specials: offerinsights,                 
                }
            }
        case ACTIONS.OFFER_INSIGHTS_FILTER_CHANGE:
            {                
                const offerinsightfilter = (action as ActionGetOfferInsightsAPI).filters
                return{
                    ...state,
                    offset:0,
                    filters: offerinsightfilter?offerinsightfilter:""
                }
            }
        case ACTIONS.OFFER_INSIGHTS_SEARCH_CHANGE:
            {                
                const offerinsightsearch = (action as ActionGetOfferInsightsAPI).search
                return{
                    ...state,
                    offset:0,
                    search: offerinsightsearch?offerinsightsearch:""
                }
            }
        case ACTIONS.SET_RANGE_DATES:
            {                
                return{
                    ...state,
                    datesRange: (action as ActionSetRangeDates).datesRange
                }
            }
        case ACTIONS.GET_USER_SETTING_API_SUCCESS:
            {                
                return{
                    ...state,
                    userSettings: (action as ActionGetUserSettingsAPISuccess).userSettings
                }
            }
    }
    return {
        ...state
    }
}

export default OfferInsightsReducer;